/** Normalize lesson category IDs from API GET (prefers `categories`, legacy fallbacks). */
export const getLessonCategoryIdsFromApiLesson = (lesson: any): string[] => {
  if (Array.isArray(lesson?.categories)) {
    return lesson.categories.filter(
      (id: unknown) => id != null && id !== '',
    ) as string[];
  }

  if (Array.isArray(lesson?.lessonCategoryIds)) {
    return lesson.lessonCategoryIds.filter(
      (id: unknown) => id != null && id !== '',
    ) as string[];
  }

  const single =
    lesson?.lessonCategoryId ?? lesson?.lessonCategory?.id ?? null;

  if (single != null && single !== '') {
    return [String(single)];
  }

  if (Array.isArray(lesson?.lessonCategories)) {
    return lesson.lessonCategories
      .map((c: any) => c?.id)
      .filter((id: unknown) => id != null && id !== '')
      .map(String);
  }

  return [];
};

/** Build `categories` payload for PUT/PATCH from Formik lesson values (`categories` primary; legacy `lessonCategoryIds`). */
export const getCategoriesPayloadFromLessonForm = (data: any): string[] => {
  if (Array.isArray(data?.categories)) {
    return data.categories.filter(
      (id: unknown) => id != null && id !== '',
    ) as string[];
  }

  if (Array.isArray(data?.lessonCategoryIds)) {
    return data.lessonCategoryIds.filter(
      (id: unknown) => id != null && id !== '',
    ) as string[];
  }

  return [];
};
